<template>
  <div id="bto-parts-palette-info">
    <ul>
      <li
        v-for="(parts, key) in partsInfo"
        :key="key"
        v-show="key == currentPartsId"
      >
        <IconBtoParts :parts-id="parts.beadId" />
        <span>{{ parts.bead_name }}</span>
        <p class="description">{{ filterDescription(parts.description) }}</p>
        <p
          v-for="(item, k) in parts.prices"
          :key="k"
          :class="isStocked(item[1]) ? 'stocked' : 'empty'"
        >
          {{ item[2] }}：￥{{ item[3] }} ➜
          <span class="price">￥{{ item[4] }}</span>
          <PartsPriceStatus :discount-rate-id="item[5]" :qty-label="item[1]" />
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import IconBtoParts from "@/components/BtoPanel/IconBtoParts.vue";
import PartsPriceStatus from "@/components/BtoPanel/PartsPriceStatus.vue";

export default {
  name: "PanelPartsInfo",

  components: {
    IconBtoParts,
    PartsPriceStatus,
  },

  props: {
    partsInfo: {
      type: Object,
    },
  },

  computed: {
    ...mapState({
      currentPartsId: (state) => state.current_parts_id,
    }),
  },

  methods: {
    filterDescription(text) {
      return text == "&nbsp;" ? "　" : text;
    },

    /**
     * 在庫情報を受け取って、販売可能かどうかを返す
     */
    isStocked(qty) {
      return "zero" == qty ? false : true;
    },
  },
};
</script>

<style scoped lang="stylus">

@css {
	#bto-parts-palette-info {
    color: #6d6d6d;
    border-color: #efebe3;
    @apply text-left text-xs border border-solid p-2 mb-2
  }
  #bto-parts-palette-info span {
    @apply ml-2
  }
  #bto-parts-palette-info p {
    border-color: #efebe3;
    @apply my-1 text-justify border-b border-dashed
  }
  #bto-parts-palette-info p.description {
    @apply my-1 px-2 text-justify border-0
  }
  #bto-parts-palette-info p.stocked {
    @apply text-xs m-0 pl-2
  }
  #bto-parts-palette-info p.stocked .price {
    color: #ee777b;
    @apply text-sm font-bold italic m-0
  }
  #bto-parts-palette-info p.empty {
    @apply text-gray-300 pl-2
  }
  #bto-parts-palette-info p strong {
    color: #ee777b;
    @apply text-sm
  }
}
</style>
